import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import {
  FlightExchangeRebookLoading,
  useFlightExchangeRebook,
} from "@tenant/flights";
import clsx from "clsx";

export interface IFlightExchangeCartQuoteProps {
  className?: string;
}

export const FlightExchangeCartQuote = (
  props: IFlightExchangeCartQuoteProps
) => {
  const { className } = props;
  const [block, cn] = useModuleBEM(
    {},
    CoreFlightsComponent.FlightExchangeRebookLoading
  );
  const { context } = useFlightExchangeRebook();

  return (
    <div className={clsx(block, className)}>
      <FlightExchangeRebookLoading
        className={cn("rebook-page-loading")}
        isLoading={context.isLoading}
        loadingTitle={context.loadingTitle}
      />
    </div>
  );
};
